export const ReportItemConfigData = `
  reportId
  embedUrl
  embedToken
`;
